import { createSelector } from 'reselect';

import { pageDataSelector } from '../root/pageDataSelector';

export const subdomainSelector = createSelector(pageDataSelector, state => state.subdomain);
